

export default class ImageApi {
    /**
     * Crops a given image to the given size and returns a DataURI of that image.
     * 
     * @param image The Image used for the cropping
     * @param sx Source X coordinate
     * @param sy Source Y coordinate
     * @param sw Source Width
     * @param sh Source Height
     * @param dw _Optional_: Destination Width. Used to resize a given screenshot
     * @param dh _Optional_: Destination Height. Used to resize a given screenshot
     */
    public static CropImageToDataURI(image: HTMLImageElement, sx: number, sy: number, sw: number, sh: number, dw: number = sw, dh: number = sh): string {
        // Create a temp canvas we can use to render the image
        var tempCanvas = document.createElement("canvas");
        var ctx = tempCanvas.getContext('2d');

        // Resize canvas
        tempCanvas.width = sw;
        tempCanvas.height = sh;

        if (!image.complete) {
            // We can only work with a complete image
            console.warn("Image is not loaded, please run this function in the image.onload callback");
            return "";
        }

        // Get its context and use it to draw the image, cropping it in the process
        tempCanvas.getContext('2d').drawImage(image,
            sx, sy,  // Starting location
            sw, sh,  // Size of the current image
            0, 0,    // Destination location, we use 0,0 for the start of the screenshot
            dw, dh); // Screenshot size

        return tempCanvas.toDataURL();
    }
}



// WEBPACK FOOTER //
// ./src/utils/ImageHelper.ts